import { v4 as uuidv4 } from 'uuid'
import { FilterOption } from './types'

export const workflowStatusFilters: FilterOption = {
  divider: false,
  groupOrAble: false,
  icon: 'approval',
  id: uuidv4(),
  inclusivity: false,
  title: 'Approval Status',
  childOptions: [
    {
      color: 'n5',
      divider: false,
      groupOrAble: false,
      icon: 'approval',
      id: 'status-draft',
      inclusivity: false,
      title: 'Draft',
      payload: {
        type_key: 'statuses',
        object: {
          status: 'draft',
        },
      },
    },
    {
      color: 'orange',
      divider: false,
      groupOrAble: false,
      icon: 'approval',
      id: 'status-pending',
      inclusivity: false,
      title: 'For Approval',
      payload: {
        type_key: 'statuses',
        object: {
          status: 'pending',
        },
      },
    },
    {
      color: 'red',
      divider: false,
      groupOrAble: false,
      icon: 'approval',
      id: 'status-denied',
      inclusivity: false,
      title: 'Needs Revision',
      payload: {
        type_key: 'statuses',
        object: {
          status: 'denied',
        },
      },
    },
    {
      color: 'green',
      divider: false,
      groupOrAble: false,
      icon: 'approval',
      id: 'status-approved',
      inclusivity: false,
      title: 'Approved',
      payload: {
        type_key: 'statuses',
        object: {
          status: 'approved',
        },
      },
    },
    {
      color: 'n8',
      divider: false,
      groupOrAble: false,
      icon: 'approval',
      id: 'status-idea',
      inclusivity: false,
      title: `Moment Placeholder`,
      payload: {
        type_key: 'statuses',
        object: {
          status: 'idea',
        },
      },
    },
  ],
}
